/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

import { validatePermissionAction } from '@actions/sessionPermission';

import { StatusString } from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import { getValueLanguageObj } from '@utils/general'


class DetailUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      justification: '',
      errors: []
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { continueAction, data } = this.props
    const { justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    return continueAction({...data, justification})
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { justification } = this.state
    let errors = {}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  render () {
    const { t, onHidden, data, validatePermissionAction } = this.props
    const { errors, loadingPage } = this.state
    
    const isFormFieldValid = (name) =>
    !!(errors[name]);
  
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );


    const children = (
      <form className="p-grid p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Correo electrónico')}:</label><br/>
          <label role="cell" className="p-text-center">{data.correo}</label>
        </div>
        <div className="p-col-6"/>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('País')}:</label><br/>
          <label role="cell" className="p-text-center">{getValueLanguageObj(JSON.parse(data.pais))}</label>
        </div>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Empresa')}:</label><br/>
          <label role="cell" className="p-text-center">{data.empresa}</label>
        </div>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Número de empleado')}:</label><br/>
          <label role="cell" className="p-text-center">{data.num_empleado}</label>
        </div>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Nombre completo')}:</label><br/>
          <label role="cell" className="p-text-center">{data.nombre}</label>
        </div>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Puesto')}:</label><br/>
          <label role="cell" className="p-text-center">{data.puesto}</label>
        </div>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Puesto reducido')}:</label><br/>
          <label role="cell" className="p-text-center">{data.puesto_reducido}</label>
        </div>
        <div className="p-col-6">
          <label role="cell" className="p-text-bold p-text-center">{t('Dirección')}:</label><br/>
          <label role="cell" className="p-text-center">{data.direccion}</label>
        </div>
        <div className="p-col-12">
          <label className="p-text-bold">{t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': isFormFieldValid(`justification`),
            })}
          />
          {getFormErrorMessage(`justification`)}
        </div>
        <div className="p-col-12 p-dialog-footer custom">
          <div className="p-d-flex p-jc-sm-between">
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">{t('Cerrar')}</span>
            </button>
            { validatePermissionAction(catalogPermissionsId.SUSPENDER_ACTIVAR_USUARIO_INTERNO) && (
              <>
              { data.estatus === StatusString.STATUS_ACTIVE && (
                <button className="p-button p-button-danger p-component" type="submit">
                  <span className="p-button-label p-c">{t('Suspender Acceso')}</span>
                </button>
              )}
              { data.estatus === StatusString.STATUS_SUSPENDED && (
                <button className="p-button p-button-success p-component" type="submit">
                  <span className="p-button-label p-c">{t('Reactivar acceso')}</span>
                </button>
              )}
              </>
            ) }
          </div>
        </div>
      </form>
    )

    return (
      <Dialog
        header={t('Datos del usuario')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '70vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapDispatchToProps = {
  validatePermissionAction
}

export default compose(withTranslation(), connect(null, mapDispatchToProps))(DetailUserModal)